export const DEFAULT_MRO_CART_HEADER = "Your Carts";

export const MRO_DEFAULT_EMPTY_ARRAY_PLACEHOLDER = [];
export const LOCAL_STORE_FIELDS = {
    IS_FROM_MRO_FOOD_CART: "isFromMROFoodCart",
    WITH_COUPON: "with_coupon",
};

export const MRO_USER_SELECTION_SESSION_STORE_KEY = "mro_user_selection_session_store";
export const MRO_CART_REUSE_SESSION_STORAGE_KEY = "cw_mro_cart_tabs_reuse_snapshot";
export const MRO_CART_REUSE_FROM_PAYMENTS_TTL_IN_MS = 60000;
export const TEXTS = {
    CANCEL: "Cancel",
    APPLY: "Apply",
    ITEM: "item",
};

export const CUSTOM_TRACKING_PREFIX = "mro";
export const CUSTOM_TRACKING_EVENTS = {
    COUPON_FLOW_SUCCESS: `${CUSTOM_TRACKING_PREFIX}_coupon_flow_success_response`,
    COUPON_FLOW_FAILURE: `${CUSTOM_TRACKING_PREFIX}_coupon_flow_failure_response`,
    COUPON_FLOW_REMOVAL_SUCCESS: `${CUSTOM_TRACKING_PREFIX}_coupon_flow_removal_success_response`,
};

export const MRO_ORDER_TOTAL_DECIMAL_PLACES = 0;

export const MRO_RX_CARD_FALLBACK_IMAGE = "portal/m/mro-rx-card-fallback.png";

export const MRO_RX_ID_KEY = "mro-rx-id-{0}";

export const MRO_CONFIRM_BUTTON_TEXT = "Confirm";

export const TAB_ERROR_MESSAGES = {
    LAST_TAB_REMOVAL: "Atleast 1 cart should be selected",
};

export const EVENT_SRC_TYPE = {
    MRO_FOOTER_CTA_ACTION: "mro_footer_cta_action",
    MRO_FOOTER_CTA_DEFAULT_ACTION: "mro_footer_cta_default_action",
    MRO_TABS_FTUE_COUNTER_WRITE_ERROR: "mro_tabs_ftue_counter_write_error",
    MRO_CHILD_CTA_UNKNOWN_ACTION: "mro_child_cta_unknown_action",
};
